export const REQUIREMENT_STATUS_TRANSLATION_KEY: { [key: string]: string } = {
	completed_allow: 'requirements.common.statuses.completed',
	completed_deny: 'requirements.common.statuses.rejected',
	expired: 'requirements.common.statuses.expired',
	expiring: 'requirements.common.statuses.expiring',
	invalidated: 'global.button.retry',
	retry: 'global.button.retry',
	under_review: 'jurisdictionRequirements.proccesinglevelHandler.title',
	update: 'requirements.common.statuses.update',
	waiting: 'jurisdictionRequirements.proccesinglevelHandler.title',
	waiting_for_user: 'requirements.common.modal.button'
};

export const REQUIREMENT_ICONS_TEXT: Record<string, string> = {
	completed_allow: 'RequirementVerifiedIcon',
	completed_deny: 'RequirementRejectedIcon',
	email_verification: 'RequirementEmailIcon',
	expired: 'RequirementExpiredIcon',
	expiring: 'RequirementExpiringIcon',
	malaysia_domestic_ringgit_borrowing: 'RequirementSelfAssessmentIcon',
	mobile_verification: 'RequirementPhoneIcon',
	proof_of_address: 'RequirementProofOfAddressIcon',
	proof_of_id: 'RequirementProofOfIdIcon',
	self_categorisation: 'RequirementSelfAssessmentIcon',
	source_of_income: 'RequirementSourceOfIncomeIcon',
	under_review: 'RequirementUnderReviewIcon',
	waiting: 'RequirementUnderReviewIcon'
};
